import {reportErrorToSentry} from 'utils/sentry';

import {draftsLocalForage} from '../store';

export async function putDraft<P = any>(payload: P, id: string) {
    await draftsLocalForage.ready();
    if (payload == null) {
        await draftsLocalForage.removeItem(id);
    } else {
        try {
            await draftsLocalForage.setItem(id, payload);
        } catch (e: unknown) {
            reportErrorToSentry(e);
        }
    }

    return id;
}

export async function readDraft<P = any>(id: string) {
    await draftsLocalForage.ready();
    const item = await draftsLocalForage.getItem<P>(id);

    return item;
}
